import { gql } from '@apollo/client';

export const SIGNIN = gql`
  query signinBackoffice($email: String!, $password: String!) {
    signinBackoffice(email: $email, password: $password) {
      id
      name
      email
      accessToken
      expiresIn
    }
  }
`;
